import * as R from "ramda"
import { naira as _naira } from "@wigxel/utils"

export const naira = R.compose(
  R.trim,
  R.replace(".00", ""),
  R.replace("NGN", ""),
  _naira
)
